


















































































































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import moment from 'moment';
import * as api from '../../../api/statistic-analysis';
import EchartOption from '@root/common/const/e-chart-options';
import _ from 'lodash';

@Component({
  name: 'ParkFlow',
  components: {
    ParkingLotSearch,
    OrganizationSearch
  }
})
export default class ParkFlow extends Mixins(TableMixin, TableWidthMixin) {
  // 仅车场视图
  parkViewOnly: boolean = false;

  // 视图类型
  viewType: number = 1;
  onViewTypeChange(value: any, oldValue: any) {
    this.current = 1;
    this.total = 0;
    this.fetchTableData();
  }

  // 节点路径
  path: any[] = [];

  // 统计颗粒度
  dimensions: string = '0';

  // 快捷时间范围按钮
  timeQuickSelect: any = {
    '0': [{ value: 1, text: '今天' }, { value: 2, text: '昨天' }],
    '1': [{ value: 3, text: '近7天' }, { value: 4, text: '近1月' }, { value: -1, text: '自定义' }],
    '2': [{ value: 5, text: '近半年' }, { value: -1, text: '自定义' }]
  };

  timeQuickButtons: any[] = this.timeQuickSelect[this.dimensions];

  // 选择的时间范围
  timeRangeType: number = 1;

  // 自定义时间
  customTime: any[] = [];
  customTimeFormat: string = 'YYYY-MM-DD';
  customTimeMode: string[] = ['date', 'date'];

  @Watch('dimensions')
  onDimensionsChange() {
    // 变换快捷按钮
    this.timeQuickButtons = this.timeQuickSelect[this.dimensions];
    this.timeRangeType = this.timeQuickButtons[0].value;
    if (this.dimensions == '1') {
      this.customTimeMode = ['date', 'date'];
      this.customTimeFormat = 'YYYY-MM-DD';
    } else if (this.dimensions == '2') {
      this.customTimeMode = ['month', 'month'];
      this.customTimeFormat = 'YYYY-MM';
    }
    this.onTimeRangeTypeChange();
  }

  onCustomTimeChange(date: any, dateString: any) {
    if (date.length === 0) {
      // 重新设置快捷按钮
      this.onDimensionsChange();
    } else {
      const [startTime, endTime] = date;
      //计算出相差天数
      if (this.dimensions == '1' && Math.abs(startTime.diff(endTime, 'months', true)) > 2) {
        this.customTime = [];
        return this.$message.error('最多选择不能超过2个月');
      } else if (this.dimensions == '2' && Math.abs(startTime.diff(endTime, 'years', true)) > 5) {
        this.customTime = [];
        return this.$message.error('最多选择不能超过5年');
      }
      if (this.dimensions == '0') {
        this.filterParam.startTime = startTime.startOf('hour').format('YYYY-MM-DD HH:mm:ss');
        this.filterParam.endTime = endTime.endOf('hour').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.dimensions == '1') {
        this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
        this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      } else if (this.dimensions == '2') {
        this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
        this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
      }
    }
  }
  onCustomTimeChange2(date: any, dateString: any) {
    // 自定义，清空快捷按钮
    const [startTime, endTime] = date;
    //计算出相差天数
    if (this.dimensions == '1' && Math.abs(startTime.diff(endTime, 'months', true)) > 2) {
      this.customTime = [];
      return this.$message.error('最多选择不能超过2个月');
    } else if (this.dimensions == '2' && Math.abs(startTime.diff(endTime, 'years', true)) > 5) {
      this.customTime = [];
      return this.$message.error('最多选择不能超过5年');
    }
    this.customTime = [startTime, endTime];
    if (this.dimensions == '0') {
      this.filterParam.startTime = startTime.startOf('hour').format('YYYY-MM-DD HH:mm:ss');
      this.filterParam.endTime = endTime.endOf('hour').format('YYYY-MM-DD HH:mm:ss');
    } else if (this.dimensions == '1') {
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    } else if (this.dimensions == '2') {
      this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
    }
  }

  onTimeRangeTypeChange() {
    this.current = 1;
    // 快捷按钮，计算时间范围
    if (this.timeRangeType !== -1) {
      this.customTime = [];
      let startTime, endTime;
      switch (this.timeRangeType) {
        case 1:
          // 今天
          startTime = moment().startOf('d');
          endTime = moment().endOf('d');
          break;
        case 2:
          // 昨天
          startTime = moment()
            .subtract(1, 'd')
            .startOf('d');
          endTime = moment()
            .subtract(1, 'd')
            .endOf('d');
          break;
        case 3:
          // 近7天
          startTime = moment()
            .startOf('d')
            .subtract(7, 'd');
          endTime = moment()
            .endOf('d')
            .subtract(1, 'd');
          break;
        case 4:
          // 近1月
          startTime = moment()
            .subtract(1, 'd')
            .startOf('d')
            .subtract(1, 'month');
          endTime = moment()
            .subtract(1, 'd')
            .endOf('d');
          break;
        case 5:
          // 近半年
          startTime = moment()
            .startOf('month')
            .subtract(5, 'month');
          endTime = moment().endOf('month');
          break;
        default:
          startTime = moment().startOf('d');
          endTime = moment().endOf('d');
      }
      if (this.dimensions == '0') {
        this.filterParam.startTime = startTime.startOf('hour').format('YYYY-MM-DD HH:mm:ss');
        this.filterParam.endTime = endTime.endOf('hour').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.dimensions == '1') {
        this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
        this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      } else if (this.dimensions == '2') {
        this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
        this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
      }
      this.fetchTableData();
    }
  }

  // 机构树
  @Getter('organizations/getUserOrgTree')
  getUserOrgTree!: any[];
  // 要查看的机构
  selectOrgId: string = '';

  onSelectOrgIdChange() {
    const org = this.findOrg(this.selectOrgId, this.getUserOrgTree);
    if (!org) {
      return;
    }
    this.childrenOrgList = org.children ? org.children : [];
    this.selectChildOrgList = [];
    this.fetchTableData();
  }

  // 子机构下拉列表
  childrenOrgList: any[] = [];
  // 选择的子机构
  selectChildOrgList: any[] = [];

  // @Watch('selectChildOrgList')
  // onSelectChildOrgListChange() {
  //   this.fetchTableData()
  // }

  // 选择的车场
  selectParkId: string = '';

  // 通道列表
  channelList: any[] = [];

  // 选择的通道
  selectChannelIds: string[] = [];

  @Watch('selectParkId')
  async onSelectParkIdChange() {
    this.selectChannelIds = [];
    // 获取最新通道列表
    const { data } = await api.infoParkChannelList({ parkId: this.selectParkId });
    this.channelList = data;
  }

  // @Watch('selectChannelIds')
  // onSelectChannelIdChange() {
  //   this.fetchTableData()
  // }

  public filterParam: any = {
    startTime: '',
    endTime: ''
  };
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  chartData: any[] = [];
  options: EchartOption = new EchartOption();
  allIn: number = 0;
  allOut: number = 0;
  timeRangeStr: string = '';

  defaultOrgId: string = '';
  defaultParkId: string = '';
  clear() {
    this.dimensions = '0';
    this.timeRangeType = 1;
    this.customTime = [];
    if (this.viewType === 1) {
      this.selectOrgId = this.defaultOrgId;
      this.selectChildOrgList = [];
    } else {
      // this.selectParkId = this.defaultParkId;
      this.selectParkId = '';
      this.selectChannelIds = [];
    }
    this.$nextTick(() => {
      this.fetchTableData();
    });
  }

  @Getter('organizations/getUserParkingList')
  parkList!: any[];

  // 先判断用户是否是单车场，然后再刷新
  @Watch('parkList')
  onPageReload() {
    this.init();
  }

  private created() {
    this.init();
  }

  // 初始化加载，确保机构树有值
  init() {
    if (this.getUserOrgTree && this.getUserOrgTree.length) {
      const root = this.getUserOrgTree[0];
      this.selectOrgId = root.id;
      this.defaultOrgId = this.selectOrgId;
      this.childrenOrgList = root.children ? root.children.filter((i: { type: string }) => i.type === 'org') : [];
      if (!this.childrenOrgList.length) {
        this.parkViewOnly = true;
        this.viewType = 2;
      }
    } else {
      return;
    }
    this.selectParkId = this.parkList.length ? this.parkList[0].id : '';
    this.defaultParkId = this.selectParkId;
    // 计算下时间范围
    this.onTimeRangeTypeChange();
  }

  findOrg(id: string, list: any[]): any {
    for (const org of list) {
      if (org.id === id) {
        return org;
      }
      if (org.children && org.children.length) {
        const result = this.findOrg(id, org.children);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // 下钻
  jumpTo(record: { orgId: string }) {
    // 车场视图不下钻
    if (this.viewType === 2) {
      return;
    }
    const org = this.findOrg(record.orgId, this.getUserOrgTree);
    if (!org) {
      return;
    }
    // 没子机构不下钻
    if (!org.children || !org.children.filter((i: { type: string }) => i.type === 'org').length) {
      this.$message.info('没有下级机构');
      return;
    }
    // 添加节点
    this.path.push(org);
    // 清空机构下拉框
    this.childrenOrgList = org.children ? org.children.filter((i: { type: string }) => i.type === 'org') : [];
    this.selectChildOrgList = [];
    this.fetchTableData();
  }
  // 返回
  backTo(item: any, index: number) {
    // 点当前节点不用再跳一遍
    if (index === this.path.length - 1) {
      return;
    }
    const org = this.path[index];
    // 移除节点
    this.path.splice(index + 1);
    // 清空机构下拉框
    this.childrenOrgList = org.children ? org.children.filter((i: { type: string }) => i.type === 'org') : [];
    this.selectChildOrgList = [];
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  getOrgIds() {
    if (this.selectChildOrgList.length) {
      return this.selectChildOrgList.join(',');
    } else if (this.childrenOrgList.length) {
      return this.childrenOrgList.map(i => i.id).join(',');
    } else {
      return '';
    }
  }

  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const param: any = {
        startDate: this.filterParam.startTime,
        endDate: this.filterParam.endTime,
        dimensions: this.dimensions,
        currPage: this.current,
        pageSize: this.pageSize
      };
      if (this.viewType === 1) {
        param.orgIds = this.getOrgIds();
      } else {
        param.parkId = this.selectParkId;
        param.channelId = this.selectChannelIds.join(',');
      }

      let res;
      if (this.viewType === 1) {
        res = await api.infoParkFlowOrgList(param);
      } else {
        res = await api.infoParkFlowList(param);
      }

      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
        if (total) {
          this.tableData.push({
            isTotal: true,
            orgName: '',
            parkEnterAccount: total.parkEnterAccount,
            parkLeaveAccount: total.parkLeaveAccount
          });
        }
      }
      await this.fetchChartData(param);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async fetchChartData(param: any) {
    // 图表查询不分页
    param.currPage = 1;
    param.pageSize = 2147483647;
    try {
      let res;
      if (this.viewType === 1) {
        res = await api.infoParkFlowOrgList(param);
      } else {
        res = await api.infoParkFlowList(param);
      }
      const data = res.data;
      if (data) {
        const { datas = [] } = data;
        // 所选机构
        this.chartData = datas;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  private async download() {
    try {
      const param: any = {
        startDate: this.filterParam.startTime,
        endDate: this.filterParam.endTime,
        dimensions: this.dimensions
      };
      if (this.viewType === 1) {
        param.orgIds = this.getOrgIds();
      } else {
        param.parkId = this.selectParkId;
        param.channelId = this.selectChannelIds.join(',');
      }
      if (this.viewType === 1) {
        await api.infoOrgExport(param);
      } else {
        await api.infoExport(param);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportLocalcashExport', '导出失败');
    }
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  getPopupContainer() {
    return this.$refs.panel['$el'];
  }

  get tableColums() {
    return this.viewType === 1
      ? [
          {
            title: '序号',
            width: 70,
            customRender: (text: any, record: any, index: number) => {
              if (record.isTotal === true) {
                return '合计';
              }
              return `${(this.current - 1) * this.pageSize + index + 1}`;
            }
          },
          {
            title: '时间',
            dataIndex: 'dataTime',
            width: 240
          },
          {
            title: '机构名称',
            dataIndex: 'orgName',
            width: 170,
            scopedSlots: { customRender: 'organName' }
          },
          {
            title: '总进场（辆）',
            dataIndex: 'parkEnterAccount',
            customRender: this.numberRender
          },
          {
            title: '总出场（辆）',
            dataIndex: 'parkLeaveAccount',
            customRender: this.numberRender
          }
        ]
      : [
          {
            title: '序号',
            width: 55,
            customRender: (text: any, record: any, index: number) => {
              if (record.isTotal === true) {
                return '合计';
              }
              return `${(this.current - 1) * this.pageSize + index + 1}`;
            }
          },
          {
            title: '时间',
            dataIndex: 'dataTime',
            width: 240
          },
          {
            title: '通道类型',
            dataIndex: 'channelType'
          },
          {
            title: '通道名称',
            dataIndex: 'channelName'
          },
          {
            title: '进场（辆）',
            dataIndex: 'parkEnterAccount',
            customRender: this.numberRender
          },
          {
            title: '出场（辆）',
            dataIndex: 'parkLeaveAccount',
            customRender: this.numberRender
          }
        ];
  }

  numberRender(value: number) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = parseFloat(value.toFixed(2)) + '';
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  refreshChart() {
    const seriesData = [];
    let x = [];
    const y0 = [];
    const y1 = [];
    const ym: Record<string, any> = {};
    // 整理数据
    if (this.chartData.length) {
      x = _.union(this.chartData.map(i => i.dataTime).sort());
      if (this.viewType == 2) {
        for (const item of this.chartData) {
          if (ym[item.channelName] === undefined) {
            ym[item.channelName] = [];
          }
        }
      }
      for (const date of x) {
        let a0 = 0,
          a1 = 0,
          am: Record<string, any> = {};
        for (const data of this.chartData) {
          if (am[data.channelName] === undefined && this.viewType == 2) {
            am[data.channelName] = 0;
          }
          if (data.dataTime === date) {
            a0 += parseFloat(data.parkEnterAccount);
            a1 += parseFloat(data.parkLeaveAccount);
            if (this.viewType == 2) {
              am[data.channelName] += parseFloat(data.parkEnterAccount) + parseFloat(data.parkLeaveAccount);
            }
          }
        }
        y0.push(a0);
        y1.push(a1);
        for (const key in ym) {
          if (am[key] !== undefined) {
            ym[key].push(am[key]);
          } else {
            ym[key].push(0);
          }
        }
      }
    }
    seriesData.push({
      name: '进场流量',
      type: 'line',
      data: y0
    });
    seriesData.push({
      name: '出场流量',
      type: 'line',
      data: y1
    });
    if (this.viewType == 2) {
      for (const key in ym) {
        seriesData.push({
          name: key,
          type: 'line',
          data: ym[key]
        });
      }
    }
    this.allIn = _.sum(y0);
    this.allOut = _.sum(y1);
    let formatStr = 'YYYY-MM-DD HH:mm:ss';
    switch (this.dimensions) {
      case '1':
        formatStr = 'YYYY-MM-DD';
        break;
      case '2':
        formatStr = 'YYYY-MM';
        break;
      default:
        formatStr = 'YYYY-MM-DD HH:mm:ss';
    }
    this.timeRangeStr = `（${moment(this.filterParam.startTime).format(formatStr)}~${moment(
      this.filterParam.endTime
    ).format(formatStr)}）`;

    const options: EchartOption = new EchartOption();
    // options.setColor(['#1890ff', '#24ccb8'])
    options.setLegend({
      show: true,
      bottom: 10
    });
    options.setGrid({
      top: '8%',
      left: '5%',
      right: '5%',
      containLabel: true
    });
    options.setXAxis(
      {
        type: 'category',
        boundaryGap: true,
        axisLabel: {
          color: '#000'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: x
      },
      true
    );
    options.setYAxis(
      [
        {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#000'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }
      ],
      true
    );
    options.setTitle({
      show: false
    });
    options.setSeries(seriesData);
    options.setTooltip({
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      }
    });
    this.options = options;
  }
}
